<template>
    <div>
        <!-- Simplified Trigger Button -->
        <div 
            class="gmf-debug-trigger"
            v-if="!removed"
            @click="isVisible = false; removeTrigger()"
            @mouseenter="isVisible = true"
            @mouseleave="isVisible = false"
        >
            <img src="https://cdn.gamifiera.com/static/1/upl/RVxzBZfaOicHeS1g.svg" alt="Debug" />
        </div>

        <!-- Simplified Debug Window -->
        <div 
            class="gmf-debug-window" 
            v-if="isVisible"
            @mouseleave="isVisible = false"
        >
            <div class="gmf-debug-window-header">
                <span class="gmf-debug-title">Settings</span>
                <span class="gmf-debug-close" @click.stop="closeDebug">×</span>
            </div>
            <div class="gmf-debug-content" style="font-family: monospace;">
                <p>
                    <strong>
                        Using defaults: {{ configObject.usingDefaults }}
                    </strong>
                </p>

                <p>merchantId: {{ configObject.merchantId }}</p>
                <p v-if="configObject.customerToken">customerToken: {{ configObject.customerToken }}</p>
                <p>Locale: {{ configObject.locale }}</p>
                <p>Version: {{ configObject.overrideVersion }}</p>
                <div v-if="configObject.previewConfig">
                    <p>Preview Config:</p>
                    <pre style="white-space: pre-wrap;">{{ JSON.stringify(configObject.previewConfig, null, 4) }}</pre>
                </div>
                <hr style="margin: 10px 0;">
                <div v-if="! configObject.usingDefaults">
                    <p>
                        API Base: {{ configObject.apiBase }}
                    </p>
                    <p>CDN Base: {{ configObject.cdnBase }}</p>
                    <p>Widget Base: {{ configObject.widgetBase }}</p>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        config: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isVisible: false,
            removed: false
        }
    },
    computed: {
        configObject() {
           return JSON.parse(this.config);
        }
    },
    methods: {
        removeTrigger() {
            this.removed = true;
            this.isVisible = false;
        },
        closeDebug() {
            this.isVisible = false;
            this.removed = true;
        }
    }
}
</script>

<style>
.gmf-debug-window {
    position: fixed;
    top: 60px;  /* Position below trigger */
    left: 20px;
    z-index: 2147483647;
    min-width: 300px;
    max-width: 500px;
    background: #fff;
    /* border: 1px solid #ddd; */
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    user-select: none;
}

.gmf-debug-window-header {
    padding: 8px 12px;
    background: #4359a9;
    color: white !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: move;
}

.gmf-debug-title {
    font-size: 14px;
    font-weight: normal;
}

.gmf-debug-close {
    cursor: pointer;
    padding: 0 6px;
    font-size: 18px;
    opacity: 0.8;
}

.gmf-debug-close:hover {
    opacity: 1;
}

.gmf-debug-content {
    padding: 12px;
    max-height: 600px;
    overflow: auto;
    font-family: 'Menlo', 'Monaco', 'Consolas', monospace;
    font-size: 13px;
    line-height: 1.6;
    color: #333;
}

.gmf-debug-trigger {
    position: fixed;
    top: 20px;
    left: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2147483646;
    transition: transform 0.2s ease;
}

.gmf-debug-trigger img {
    width: 32px;
    height: 32px;
    pointer-events: none;
}
</style>